import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['label'];
  static values = {
    sourceSelector: Array,
    visible: Array 
  }

  connect() {
    const controller = this;
    
    this.sourceFields = [];
    this.sourceSelectorValue.forEach(selector => {
      let sourceField = document.querySelector(selector);
      sourceField.addEventListener('change', (e) => controller.toggleElement());
      this.sourceFields.push(sourceField);
    });

    if (this.hasLabelTarget) {
      this.originalLabel = this.labelTarget.innerHTML;
    }
    this.toggleElement();
  }

  toggleElement() {
    let visible = null
    let that = this
    this.sourceFields.forEach(sourceField => {
      let found = that.visibleValue.find((v) => v[0] == sourceField.value);
      if (found) {
        visible = found;
      }
    });

    if (this.hasLabelTarget) {
      if (visible && visible[1]) {
        this.labelTarget.innerHTML = visible[1];
      } else {
        this.labelTarget.innerHTML = this.originalLabel;
      }
    }

    this.element.classList.toggle('d-none', !visible);
  }
}
